import React from "react";
import { Link } from "react-router-dom";
import { dishes } from "../data/dishes";
import { useTheme, useDocumentTitle } from "../hooks/useSite";

export default function NotFoundPage() {
  useTheme(dishes[0]);
  useDocumentTitle("Page not found");
  return (
    <section className="ro-error">
      <div className="ro-container">
        <h1>
          A little <span className="ro-outline">detour.</span>
        </h1>
        <p>This page isn’t on the menu.</p>
        <div className="ro-availability__actions">
          <Link className="ro-pill ro-pill--solid" to="/">
            Back home
          </Link>
          <Link className="ro-pill ro-pill--solid" to="/menu">
            Explore our menu
          </Link>
        </div>
      </div>
    </section>
  );
}
